import React, { useEffect, useState } from 'react';
import { jsPDF } from 'jspdf';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { CustomButton } from '../../widgets';
import { formatCompletionDate, getScore } from './utils';
import { getCourseCertificate } from './apiController';

const CertificateDetail = ({
  certificateData,
  onBack,
  profileData
}) => {
  const [preview, setPreview] = useState<string | null>(null);
  const templateUrl = "/courseBadges/certificate.png";
  let userData: any = localStorage.getItem('coguide_user');
  let userName;
  if(profileData.first_name && profileData.last_name){
    userName = profileData.first_name + " " +profileData.last_name;
  }else{
    userName = profileData.full_name
  }
  const courseTitle = certificateData?.title;
  const courseDescription = certificateData?.description;
  const score = getScore(certificateData?.status_obj[0]?.result);
  const completionDate = formatCompletionDate(certificateData?.status_obj[0]?.completed_date);

  // useEffect(() => {
  //   getCertificateDetail();
  // }
  // , []);

  // async function getCertificateDetail() {
  //   const response = await getCourseCertificate(certificateData?.id, userData?.UserNumber );
    
  //   console.log(response)
  // }

  const certificateContent = `has successfully completed ${courseTitle} on this day, ${completionDate}, in recognition of their dedication and excellence.`;

const generatePreview = async () => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx) return;

  const img = new Image();
  img.src = templateUrl;

  try {
    await new Promise((resolve, reject) => {
      img.onload = resolve;
      img.onerror = reject;
    });

    canvas.width = 1200;
    canvas.height = 850;
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    // Function to wrap text
    const wrapText = (text, x, y, maxWidth, lineHeight) => {
      const words = text.split(" ");
      let line = "";
      for (let i = 0; i < words.length; i++) {
        const testLine = line + words[i] + " ";
        const metrics = ctx.measureText(testLine);
        const testWidth = metrics.width;

        if (testWidth > maxWidth && i > 0) {
          ctx.fillText(line, x, y);
          line = words[i] + " ";
          y += lineHeight;
        } else {
          line = testLine;
        }
      }
      ctx.fillText(line, x, y);
    };

    // Add certificate text
    ctx.font = "bold 44px Times New Roman";
    ctx.textAlign = "center";
    ctx.fillStyle = "black";
    ctx.fillText(userName, 600, 440);

    ctx.font = "30px Times New Roman";
    wrapText(certificateContent, 600, 500, 800, 40); // Wrapped content

    // ctx.fillText(completionDate, 900, 700);

    // // Add score
    // ctx.font = "25px Times New Roman";
    // ctx.fillText(`Score: ${score}%`, 300, 700);

    setPreview(canvas.toDataURL("image/png"));
  } catch (error) {
    console.error("Error generating preview:", error);
  }
};

  useEffect(() => {
    generatePreview();
  }, []); // Generate preview when component mounts

  const downloadCertificate = () => {
    const pdf = new jsPDF("landscape");
  
    pdf.addImage(templateUrl, "PNG", 0, 0, 297, 210);
    pdf.setFont("times", "bold");
    pdf.setFontSize(30);
    pdf.text(userName, 150, 108, { align: "center" });
  
    // pdf.setFontSize(24);
    // pdf.text(courseTitle, 148, 130, { align: "center" });
    pdf.setFont("times", "normal");
    pdf.setFontSize(18);
    pdf.setTextColor(100, 100, 100);
    // pdf.text(completionDate, 148, 160, { align: "center" });
  
    // pdf.text(`Score: ${score}%`, 74, 160, { align: "center" });
  
    // Function to wrap text in PDF
    const wrapTextInPDF = (doc, text, x, y, maxWidth, lineHeight) => {
      const words = text.split(" ");
      let line = "";
      let currentY = y;
  
      for (let i = 0; i < words.length; i++) {
        const testLine = line + words[i] + " ";
        const testWidth = doc.getTextWidth(testLine);
  
        if (testWidth > maxWidth && i > 0) {
          doc.text(line, x, currentY, { align: "center" });
          line = words[i] + " ";
          currentY += lineHeight;
        } else {
          line = testLine;
        }
      }
      doc.text(line, x, currentY, { align: "center" });
    };
  
    // Wrapped certificate content
    wrapTextInPDF(pdf, certificateContent, 148, 132, 200, 10);
  
    pdf.save(`${userName}_${courseTitle}_Certificate.pdf`);
  };
  

  return (
    <div className="certificate-detail">
      <div className="certificates-detail-title">
      <ArrowLeftOutlined className="text-white text-2xl mx-2 cursor-pointer"
                            onClick={onBack} 
                        /> 
        <span>Course Certificate</span>
      </div>
      
      <div className="certificate-content">
        <div className="certificate-info">
          <div className="info-section">
            <h1>{courseTitle}</h1>
            <div className="info-grid">
              <div className="info-item">
                <label>Description</label>
                <span>{courseDescription}</span>
              </div>
              <div className="info-item">
                <label>Completion Date</label>
                <span>{completionDate}</span>
              </div>
              <div className="info-item">
                <label>Score Achieved</label>
                <span>{score}%</span>
              </div>
            </div>
          </div>
        </div>

        <div className="certificate-preview">
          <div className="preview-container">
            {preview ? (
              <img src={preview} alt="Certificate Preview" />
            ) : (
              <div className="loading">Generating preview...</div>
            )}
          </div>
          <div className='download-certificate-button'>
            <CustomButton text="Download Certificate" type="primary" onClick={downloadCertificate} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificateDetail;